module.exports = __webpack_public_path__ + "static/media/vote.ddf2f3a1.jpg";